module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/race-trophy-a73611d1c8dc733c.png"+" 103w",
        images: [{path: __webpack_public_path__ + "assets/images/race-trophy-a73611d1c8dc733c.png",width: 103,height: 128}],
        src: __webpack_public_path__ + "assets/images/race-trophy-a73611d1c8dc733c.png",
        toString: function(){return __webpack_public_path__ + "assets/images/race-trophy-a73611d1c8dc733c.png"},
        
        width: 103,
        height: 128
      }